import React from "react";
import { useRouter } from "next/router";
import { useLogout } from "@/hooks/useLogout";
import { useTrialBlock } from "@/hooks/useTrialBlock";

interface UserMenuProps {
  setIsMenuClick: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * 헤더 프로필 드롭다운 메뉴.
 *
 * 가드: sessionStorage.role === "TEACHER" 이면 학생 전용 메뉴(마이페이지/결제관리/회원정보 수정)
 * 3개를 렌더하지 않고 "로그아웃"만 노출. STUDENT 또는 role 미저장(legacy) 사용자는 기존 4개 메뉴 그대로.
 *
 * ★ prerender 안전:
 * - `output:"export"` 환경에서 모듈 top-level `sessionStorage` 호출은 빌드 깨짐.
 * - 컴포넌트 함수 본문 안 `useEffect` 안에서만 평가 + 초기값 false로 SSR/CSR 첫 렌더 일관성 확보.
 * - 첫 렌더에서는 isTeacher=false (=학생 기본) → role=TEACHER 사용자는 마운트 직후 effect로 4개 → 1개로 줄어드는 깜빡임이 ms 단위 발생. 메뉴 드롭다운은 사용자가 명시적으로 클릭해서 열기 때문에 effect는 마운트 시점에 이미 평가된 상태로 노출.
 */
const UserMenu: React.FC<UserMenuProps> = ({ setIsMenuClick }) => {
  const router = useRouter();
  // 로그아웃 커스텀 훅 사용
  const handleLogout = useLogout();
  // 체험용 계정: 결제관리/회원정보 진입 대신 접근 제한 모달
  // (마이페이지는 실제 라우팅으로 풀림. 결제관리·회원정보 수정은 그대로 차단 유지)
  const openTrialBlock = useTrialBlock();

  const [isTeacher, setIsTeacher] = React.useState(false);
  React.useEffect(() => {
    if (typeof window === "undefined") return;
    setIsTeacher(sessionStorage.getItem("role") === "TEACHER");
  }, []);

  return (
    <div className="user-menu-layout">
      {!isTeacher && (
        <>
          <button
            type="button"
            onClick={() => {
              setIsMenuClick(false); // 메뉴 닫기
              router.push("/my");
            }}
            className="user-menu-item"
          >
            마이페이지
          </button>
          <button
            type="button"
            onClick={() => openTrialBlock("결제관리")}
            className="user-menu-item"
          >
            결제관리
          </button>
          <button
            type="button"
            onClick={() => openTrialBlock("회원정보 수정")}
            className="user-menu-item"
          >
            회원정보 수정
          </button>
        </>
      )}
      <button
        type="button"
        onClick={() => {
          setIsMenuClick(false); // 메뉴 닫기
          handleLogout(); // 로그아웃 처리
        }}
        className="user-menu-item"
      >
        로그아웃
      </button>
    </div>
  );
};
export default UserMenu;
